import { useRef } from 'react';
import PropTypes from 'prop-types';
import { Virtuoso } from 'react-virtuoso';
import _startCase from 'lodash/startCase';
import LibraryItem from 'Components/profile/LibraryItem';
import LibraryItemSkeleton from 'Components/profile/LibraryItemSkeleton';
const SKELETON_ITEMS = [...Array(10)];

const LibraryList = ({
  country,
  isLoading,
  isVideo,
  itemList,
  itemMap,
  onDeleteListItem,
  onLoadMore,
  shouldLoadMore,
  strings,
  type,
}) => {
  const listRef = useRef(null);
  const itemCount = itemList.length;

  const handleLoadMore = () => {
    if (shouldLoadMore) onLoadMore();
  };

  const getItem = (index) => itemMap[itemList[index]];

  const renderItem = (index) => {
    const item = getItem(index);
    return (
      <LibraryItem
        {...item}
        country={country}
        onDelete={onDeleteListItem}
        isVideo={isVideo}
        strings={strings}
      />
    );
  };

  const renderFooter = () => {
    // On initial load, render full screen of skeletons
    if (isLoading && !itemCount) {
      listRef.current?.scrollToIndex({ align: 'start', index: 0 });
      return SKELETON_ITEMS.map((item, index) => (
        <LibraryItemSkeleton key={index} isVideo={isVideo} />
      ));
    }

    // On subsequent loads, render single skeleton
    if (shouldLoadMore) return <LibraryItemSkeleton isVideo={isVideo} />;

    return <div className="spacer"></div>;
  };

  return (
    <div className="library-list">
      <label>{`Saved ${_startCase(type.toLowerCase())}`}</label>
      <Virtuoso
        className="library-list__virtuoso"
        endReached={handleLoadMore}
        footer={renderFooter}
        item={renderItem}
        ref={listRef}
        totalCount={itemCount}
      />
    </div>
  );
};

LibraryList.propTypes = {
  country: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isVideo: PropTypes.bool.isRequired,
  itemList: PropTypes.array.isRequired,
  itemMap: PropTypes.object.isRequired,
  onDeleteListItem: PropTypes.func.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  shouldLoadMore: PropTypes.bool.isRequired,
  strings: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
};

LibraryList.defaultProps = {};

export default LibraryList;
